export const SEARCH_ICON = 'search-icon';
